import {
  SignUpQuestionId,
  signUpQuestionModules,
} from '../questionService/questionModules/signUpQuestionModules'
import {
  Answer,
  getFirstQuestion,
  getLastAnsweredQuestion,
  getNextQuestion,
} from '../questionService/questionService'
import {
  SignUpScreenId,
  signUpScreens,
} from './screenDefinitions/signUpScreens'
import { SignUpAnswers, SignUpScreen } from './types'

export const getScreenFromId = (screenId: SignUpScreenId) =>
  signUpScreens[screenId]

export const getScreenIdFromQuestionId = (
  questionId: SignUpQuestionId
): SignUpScreenId => {
  // assumes each question only appears on 1 screen
  const [id] = Object.entries(signUpScreens).find(([_, screen]) =>
    screen.questions.includes(questionId)
  )!
  return id as SignUpScreenId
}

export const getNextScreenId = (
  answers: SignUpAnswers
): SignUpScreenId | null => {
  const answersMap = new Map<string, Answer>(Object.entries(answers))

  const nextQuestion = getNextQuestion(signUpQuestionModules, answersMap)

  if (nextQuestion) {
    return getScreenIdFromQuestionId(nextQuestion.id as SignUpQuestionId)
  }
  return null
}

export const getPreviousScreenId = (
  answers: SignUpAnswers,
  questionsOnCurrentScreen: SignUpScreen['questions']
): SignUpScreenId | null => {
  const answersFromPreviousScreens = Object.entries(answers).filter(
    ([questionId, _]) =>
      !questionsOnCurrentScreen.includes(questionId as SignUpQuestionId)
  )
  const answersMap = new Map<string, Answer>(answersFromPreviousScreens)
  const lastAnsweredQ = getLastAnsweredQuestion(
    signUpQuestionModules,
    answersMap
  )
  if (lastAnsweredQ) {
    return getScreenIdFromQuestionId(lastAnsweredQ.id as SignUpQuestionId)
  }
  return null
}

export const isFirstScreen = (
  questionsOnCurrentScreen: SignUpScreen['questions']
) => {
  const firstQuestionId = getFirstQuestion(signUpQuestionModules).id
  return questionsOnCurrentScreen.includes(firstQuestionId as SignUpQuestionId)
}
